import React from 'react';
import LikeIcon from './../../Icons/favourite/favourite';
import Share from '@sfly/uig-svg-icon/action/share';
import FavouriteSelected from './../../Icons/favouriteSelected/likedAlready';
import helpers from './../../utils/helper';
import {connect} from 'react-redux';
import TooltipDropdownMenu from '@sfly/uig-tooltip-dropdown-menu';
import MakeMyOwnIcon from './../../Icons/makeMyOwn/makeMyOwn';
import adobeDTM from "./../../utils/adobeDTM";
import API_CONSTANTS from './../../constants/constants'
import shareService from './../../../redux/utils/shareService';
import omnitureCalls from './../../utils/omnitureCalls';
import CommentIcon from './../../Icons/comment/comment';
import CloseIcon from './../../Icons/close/close';
import likesCommentOmnitureCalls from './../../../redux/utils/likeCommentOmnitureCalls';
import {
    checkIfAlreadyLiked,
    getLikes,
    likeSharedProduct,
    redirectToSignIn,
    unlikeSharedProject
} from './../../../redux/actions'
import DOMPurify from 'dompurify';

class Notification extends React.Component {
    render() {
        return (
            <div id="share-widget-notification" style={{'visibility': 'visible'}}>

                {
                    this.props.message
                }
            </div>)
    }
}


class InformativeNotification extends React.Component {
    showLikesToggele = () => {
        this.props.showLikesToggele(false);
    }

    render() {
        let {people} = this.props;
        people = people || [];
        const originalPeopleCount = Object.assign([], people);
        if (people.length > API_CONSTANTS.TOTAL_LIKES_TO_SHOW) {
            people.length = API_CONSTANTS.TOTAL_LIKES_TO_SHOW;
        }
        return (
            <div id="informative-notification" style={{'visibility': 'visible'}}>
                <label onClick={this.showLikesToggele} className="close">
                    <CloseIcon/>
                </label>
                <p className="header-title">Liked by {originalPeopleCount.length} people</p>
                <div>
                    {
                        people.map((person, index) => {
                            return `${person.userName} ${index != (people.length - 1) ? ', ' : ''}`
                        })
                    }
                    {
                        originalPeopleCount.length > people.length &&
                        (originalPeopleCount.length - people.length + " more")
                    }

                    {/* <actionClose /> */}
                </div>
            </div>)
    }
}

class CallToActionBlock extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            likedAlready: false,
            showToolTip: false,
            notificationMessage: '',
            showNotification: false,
            isCalledPending: true
        }
        this.adobeEvents = new adobeDTM();
    }

    checkPendingActions(userId, users, originalSharedProjectGuid) {
        const likeProject = helpers.getLocalStorageByKey('likeProject');
        const shareProject = helpers.getLocalStorageByKey('shareProject');
        if (likeProject == "true") {
            this.likeSharedProject(userId, users, originalSharedProjectGuid);
            helpers.removeLocalStorage('likeProject');


        }
        if (shareProject == 'true') {
            this.shareWidgetInitialization();
            helpers.removeLocalStorage('shareProject');

        }
    }

    likeOrUnline = () => {

        if (this.props.user.userNotLoggedIn) {
            helpers.preservePendingCalls({
                totalComments: this.props.comments.comments.length,
                likeProject: true
            });
            this.redirectToSignIn();
            return;
        }
        const {share, user} = this.props;
        if (this.checkIfAlreadyLiked()) {
            this.unlikeSharedProject(user.userId, share.likeMapping.users, this.props.originalSharedProjectGuid);
        } else {
            this.likeSharedProject(user.userId, share.likeMapping.users, this.props.originalSharedProjectGuid);
        }

    }


    logOmnitureEvent = (location, url, redirect, logAdditionalRules) => {
        this.adobeEvents.clickDTMEvent(location, url, logAdditionalRules);
        if (redirect === "true")
            setTimeout(function () {
                window.location.href = DOMPurify.sanitize(url);
            }, 100);
    }

    /**
     * log omniture recondrds and redirect
     */
    personalize = () => {
        this.logOmnitureEvent(
            "personalize",
            this.props.editProjectUrl,
            "true",
            "true"
        )
    }

    // renders tooltip content on hover of like
    renderContents = () => {
        const {likeMapping} = this.props.share;
        let users = [];
        if (likeMapping) {
            users = likeMapping.users;
        }
        return <div>
            {
                users.map((user, index) => {
                    if (index < 10) {
                        return (<li key={index}>{
                            user.userName + ((index < users.length - 1) ? " " : "")
                        }</li>)
                    } else if (index == 10) {
                        return (<li key={index}>{users.length - 10} More</li>)
                    }
                })
            }
        </div>;
    }

    shouldShowToolTip = () => {
        const {likeMapping} = this.props.share;
        const {userId} = this.props.user;
        const {showToolTip} = this.state;
        let users = [];
        if (likeMapping) {
            users = likeMapping.users;
        }
        return (!helpers.isMobile() && users.length > 0 && showToolTip);
    }

    redirectToSignIn = () => {
        redirectToSignIn();
    }

    likeSharedProject = (userId, users, originalSharedProjectGuid) => {
        const {family_name, given_name, email} = this.props.user;
        this.props.likeSharedProduct({
                userId,
                family_name,
                given_name,
                email
            },
            users,
            originalSharedProjectGuid
        );
    }

    unlikeSharedProject = (userId, users, originalSharedProjectGuid) => {
        this.props.unlikeSharedProject(userId, users, originalSharedProjectGuid);
    }

    checkAlreadyLiked = () => {
        const {likeMapping} = this.props.likesCommentDataReducer;
        var likedAlready = helpers.isProjectLikedByMe(likeMapping.users, this.props.likesCommentDataReducer.userId);
        this.setState({
            likedAlready
        });
    }

    componentWillReceiveProps(nextProps) {
        const {share, user} = nextProps;
        if (share.liked && user.userId) {
            this.props.getLikes(this.props.originalSharedProjectGuid);
        }

        if (user.userId && this.state.isCalledPending) {

            this.checkPendingActions(user.userId, share.likeMapping.users, this.props.originalSharedProjectGuid);
            this.setState({
                isCalledPending: false
            })
        }
    }


    checkIfAlreadyLiked = () => {
        const {share, user} = this.props;
        const currentUser = user.userId;
        const users = share.likeMapping.users;
        if (!users || !(users instanceof Array) || !currentUser) {
            return false;
        }
        for (var i = 0; i < users.length; i++) {
            if (users[i].userId === currentUser) {
                return true;
            }
        }
        return false;
    }

    onMouseEnter = () => {
        console.log("Enter")
        this.setState({
            showToolTip: true
        });
    }

    onMouseLeave = () => {
        console.log("Exit")
        this.setState({
            showToolTip: false
        });
    }

    /**
     * Params { String } type
     * Create the promise for given shareURL
     */
    generateLink = (type) => {
        const {shareUrl} = this.props;
        var promise = new Promise(function (resolve, reject) {
            switch (type) {
                case 'facebook':
                    resolve({
                        type: 'facebook',
                        url: shareUrl
                    });
                case 'link':
                    resolve({
                        type: 'link',
                        url: shareUrl
                    });
            }

        });
        return promise;
    }

    hideNotification = () => {
        setTimeout(() => {
            this.setState({
                showNotification: false,
                notificationMessage: ''
            });
        }, 3000);
    }

    /**
     * Params { Object } action
     * Params { Object } options
     * callback for share widget which can track activities on widget
     */
    action = (action, options) => {
        this.handleOmniture(action, options);
        const truthyValues = ['shareLink', 'facebookShare', 'close'];
        let message;
        switch (action) {
            case 'shareLink':
                if (options.type === 'link') {
                    message = 'LINK COPIED'
                } else {
                    message = 'PROJECT SHARED VIA FACEBOOK'
                }
                this.setState({
                    showNotification: true,
                    notificationMessage: message
                });
                this.hideNotification()
                break;
        }
        if (truthyValues.indexOf(action) > -1) {
            this.Share.unmount();
        } else if (action === 'sendEmail') {
            this.sendEmail(action, options);
        }

    }
    /**
     *  Params { Object } action
     *  Params { Object } options
     * handle the omniture call based on the action
     */
    handleOmniture = (action, options) => {
        const criteria = options ? (options.event ? options.event : options.type) : action;
        switch (criteria) {
            case 'launch':
                omnitureCalls.clickOnIcons('share-product:share project');
                break;

            case 'clickViaLink':
                omnitureCalls.clickOnIcons('landing page: link click');
                break;

            case 'clickCopyLinkButton':
                omnitureCalls.clickOnIcons('landing page: link share');
                break;

            case 'clickEmail':
                omnitureCalls.clickOnIcons('landing page: email click');
                break;

            case 'clickFacebook':
                omnitureCalls.clickOnIcons('share project: facebook click');
                break;

            case 'clickShare':
                omnitureCalls.clickOnIcons('share project: facebook share');
                break;

            case 'facebook':
                omnitureCalls.clickOnIcons('share project: facebook share success');
                break;


        }
    }

    capitalize(lower) {
        if (!lower) {
            return "";
        }
        return lower.replace(/^\w/, function (chr) {
            return chr.toUpperCase();
        });

    }

    /**
     * Returns capitalized full name
     */
    getFullName = () => {
        const {family_name, given_name} = this.props.user;
        return this.capitalize(given_name) + " " + this.capitalize(family_name);

    }
    /**
     * Params { Object } action
     * Params { Object } options
     * callback for share widget which can track activities on widget
     */
    sendEmail = (action, options) => {
        let totalEmailContacts = options.recipients.length;
        options.sharedBy = this.getFullName();
        shareService.sendEmail(options, this.props.user.accessToken)
            .then(() => {
                this.Share.unmount(true);
                this.setState({
                    showNotification: true,
                    notificationMessage: 'PROJECT SHARED WITH ' + totalEmailContacts + (totalEmailContacts === 1 ? ' PERSON' : ' PEOPLE')
                });
                omnitureCalls.clickOnIcons('share project: email share');
                this.hideNotification();
            })
    }

    error = (error) => {
        omnitureCalls.clickOnIcons('landing page: facebook share cancel');
    }

    // initialized the share widget
    shareProduct = () => {
        if (this.props.user.userNotLoggedIn) {
            helpers.preservePendingCalls({
                shareProject: true,
                totalComments: this.props.comments.comments.length
            });
            this.redirectToSignIn();
            return;
        }
        this.shareWidgetInitialization();
    }

    shareWidgetInitialization() {
        var options = {
            callbacks: {
                action: this.action,
                error: this.error,
                generateLink: this.generateLink
            },
            data: {
                platform: 'MY_PROJECT',
                view: 'home'
            },
            env: 'dev'
        };
        var ShareWidget = window.ShareWidget;
        this.Share = new ShareWidget(options);

        this.Share.init();
    }

    // Display the people who liked the project
    showLikesToggele = (showLikes) => {
        if (!helpers.isMobile()) {
            return;
        }
        this.setState({
            showLikes
        });
    }

    //scroll to comment box
    commentOnProduct = () => {
        const element = document.getElementById('add-comment-id');
        if (element) {
            element.focus();
            return;
        }
        likesCommentOmnitureCalls.callOmniture('share-product:view comments');

        const editElement = document.getElementById('edit-comment-Id');
        if (editElement) editElement.focus();
        return;
    }

    render() {
        const {likeMapping, recievedLikes} = this.props.share;
        const {totalComments} = this.props.comments;
        let likesCount = '';
        const style = {marginLeft: '22px'};
        if (totalComments < 10) {
            style.marginLeft = '25px'
        }
        if (likeMapping) {
            likesCount = likeMapping.likesCount;
        }
        if (!recievedLikes && false) {
            return <div className="spinner">
                <img src={API_CONSTANTS.SPINNER_URL}/>
            </div>
        }
        return (<div className="cta-container" onMouseLeave={this.onMouseLeave}
                     onMouseEnter={this.onMouseLeave}>

            <div className="tooltip-container">
                {
                    this.state.showNotification &&
                    <Notification message={this.state.notificationMessage}/>
                }
                {
                    this.shouldShowToolTip() &&
                    <TooltipDropdownMenu>
                        <ul>
                            {
                                this.renderContents()
                            }
                        </ul>
                    </TooltipDropdownMenu>
                }

            </div>
            <div id="likedBy"
                 onMouseEnter={this.onMouseEnter}>
                <div className="cta-icons" style={{marginLeft: "0px"}}>
                    <div onClick={this.likeOrUnline}>
                        {
                            this.checkIfAlreadyLiked() ? <div className="favouriteSelected">
                                <FavouriteSelected/>
                            </div> : <LikeIcon/>
                        }
                    </div>
                    <div>
                        {
                            likesCount <= 1
                                ?
                                <label onClick={() => {
                                    this.showLikesToggele(true)
                                }}> {
                                    likesCount === 0 ? "" : likesCount
                                } LIKE</label>
                                :
                                (<label onClick={() => {
                                    this.showLikesToggele(true)
                                }}>{likesCount} LIKES</label>)}

                    </div>
                </div>
            </div>
            <div className="cta-icons mobile-view-comments" style={style} onClick={this.commentOnProduct}>
                <div>
                    <CommentIcon/>
                    <div>
                        <label>
                            {
                                totalComments > 0 ? totalComments : ""
                            }
                            {
                                totalComments > 1 ? " COMMENTS" : " COMMENT"
                            }
                        </label>
                    </div>
                </div>

            </div>
            <div className="cta-icons share-icon" style={helpers.isMobile() ? style : {}} onClick={this.shareProduct}>
                <Share/>
                <div>
                    <label>SHARE</label>
                </div>

            </div>
            <div className="cta-icons" style={helpers.isMobile() ? style : {}}>
                <div onClick={this.personalize}>
                    <MakeMyOwnIcon/>
                    <div>
                        <label>PERSONALIZE</label>
                    </div>
                </div>

            </div>

            {
                this.state.showLikes &&
                <InformativeNotification showLikesToggele={this.showLikesToggele} people={likeMapping.users}/>

            }


        </div>)
    }
}


const mapStateToProps = state => {
    return {
        share: state.share,
        user: state.user,
        comments: state.comments
    };
};

const mapDispatchToProps = {
    checkIfAlreadyLiked,
    likeSharedProduct,
    unlikeSharedProject,
    getLikes
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CallToActionBlock);
  